import { render, staticRenderFns } from "./ChooseNewSubscription.vue?vue&type=template&id=04dc793c&"
import script from "./ChooseNewSubscription.vue?vue&type=script&lang=js&"
export * from "./ChooseNewSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports